var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29642 1.6423C1.85661 1.09611 2.61022 0.794373 3.38998 0.794373H12.0465C12.8262 0.794373 13.5799 1.09611 14.14 1.6423C14.7013 2.18947 15.0222 2.938 15.0222 3.72496V5.48331H12.6777V3.72496C12.6777 3.57923 12.6186 3.43328 12.5034 3.32094C12.3871 3.20762 12.2233 3.13884 12.0465 3.13884H3.38998C3.21313 3.13884 3.04932 3.20762 2.93309 3.32094C2.81788 3.43328 2.75878 3.57923 2.75878 3.72496V14.2751C2.75878 14.4208 2.81788 14.5668 2.93309 14.6791C3.04932 14.7924 3.21313 14.8612 3.38998 14.8612H12.0465C12.2233 14.8612 12.3871 14.7924 12.5034 14.6791C12.6186 14.5668 12.6777 14.4208 12.6777 14.2751V12.5167H15.0222V14.2751C15.0222 15.062 14.7013 15.8106 14.14 16.3577C13.5799 16.9039 12.8262 17.2057 12.0465 17.2057H3.38998C2.61022 17.2057 1.85661 16.9039 1.29642 16.3577C0.735216 15.8106 0.414307 15.062 0.414307 14.2751V3.72496C0.414307 2.93801 0.735216 2.18947 1.29642 1.6423ZM17.4117 4.41164L22.0001 9.00002L17.4117 13.5884L15.7539 11.9306L17.5123 10.1723H8.03383V7.82778H17.5123L15.7539 6.06943L17.4117 4.41164Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.adeee0417e482ed9294120e0538ff803.svg";
export { ForwardRef as ReactComponent };